import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import PlausibleProvider from './components/PlausibleProvider';
import PlausibleScript from './components/PlausibleScript';
import Home from './routes/Home';
import PrivacyPolicy from './routes/PrivacyPolicy';
import TermsOfService from './routes/TermsOfService';
import NotFound from './routes/NotFound';
import './styles/global.css';

const App: React.FC = () => {
  // Configuration for Plausible Analytics
  const plausibleConfig = {
    domain: 'rythm.fm', // Change this to your registered domain in Plausible
    trackOutboundLinks: true,
    trackFileDownloads: true,
    // If you're using a custom Plausible instance, uncomment and set this:
    // apiHost: 'https://custom-plausible-host.com'
  };

  return (
    <PlausibleProvider {...plausibleConfig}>
      <HelmetProvider>
        <Router>
          <div className="app">
            {/* PlausibleScript for tracking page views with react-router */}
            <PlausibleScript />
            
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/terms" element={<Navigate to="/terms-of-service" replace />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </Router>
      </HelmetProvider>
    </PlausibleProvider>
  );
};

export default App;
